import * as React from 'react'
import BaseIcon from 'react-icon-base'

const TagIconSmall = props => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width="16" height="16" fill="#2ED8A7" rx="8" />
      <path fill="#FEFEFE" d="M5.5 8.5v3H5v-7h6l-2 2 2 2H5.5z" />
    </g>
  </BaseIcon>
)

export default TagIconSmall
